export const BookingDetailsBoxWrapper = ({children, elementClassName=''}: 
    {children: JSX.Element, elementClassName: string})=> {

    return <div className={`bookings-details-item ${elementClassName}`} >
    <div className="content">
        {children}
    </div>
</div>
}